var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v(" Tu treba ubaciti pdf make ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }